module.exports = __webpack_public_path__ + "static/media/left-top-background.6b399e8c.png";